import * as React from 'react';

import BodyWrapper, { LayoutTypes } from '../layout/BodyWrapper';
import DispensariesHeader from './DispensariesHeader';
import DispensariesList from './DispensariesList';
import Helmet from 'react-helmet';

/**
 * This is the dispensary listing page for delivery
 */
const Dispensaries = () => {
  return (
    <BodyWrapper pageLayout={LayoutTypes.Narrow}>
      <Helmet>
        <title>Zip Run - Delivery</title>
      </Helmet>
      <DispensariesHeader title="Order Delivery" />
      <DispensariesList />  
    </BodyWrapper>
  )
}

export default Dispensaries;
